import React from 'react';
import {Helmet} from 'react-helmet';

//components
import About from './About';
import Services from './Services';
import Blog from './Blog';

const Index = () => {
    return (
        <section className="home">
            
            <Helmet>
                <title>Powerscript</title>
                <meta name="description" content="learn new hacks of how to protect yourself on the net"/>
            </Helmet>

            <div className="container">
                <section id="about">
                   <About />
                </section>
                <section id="services">
                   <Services />
                </section>
                <section id="blog">
                    <Blog />
                </section>       
            </div>

        </section>
    )
};


export default Index;